export default function getClassNameFromArray(arrayOfClasses) {
  try {
    return arrayOfClasses.filter(Boolean).join(' ') || null;
  } catch (error) {
    console.error(error);
    return null;
  }
}
